import React from 'react';
import { Mail, CreditCard, Download } from 'lucide-react';
export function HowItWorks() {
  return <section className="bg-white py-4 md:py-8 px-4 border-b border-gray-100" data-id="element-107">
      <div className="max-w-4xl mx-auto" data-id="element-108">
        <h2 className="text-xl md:text-2xl font-bold text-gray-900 mb-3 md:mb-6 text-center" data-id="element-109">
          🔽 ¿Cómo recibís el material?
        </h2>

        <div className="flex flex-col md:flex-row items-stretch md:items-center justify-center gap-2 md:gap-8 text-center" data-id="element-110">
          <div className="flex items-center gap-3 justify-center py-2" data-id="element-111">
            <div className="w-10 h-10 bg-orange-100 rounded-full flex items-center justify-center text-[#f97316] flex-shrink-0" data-id="element-112">
              <Mail className="w-5 h-5" data-id="element-113" />
            </div>
            <p className="text-gray-700 text-base" data-id="element-114">
              <span className="font-bold" data-id="element-115">1.</span> Comprás e ingresás tu correo
            </p>
          </div>
          <span className="hidden md:block text-gray-300 text-2xl" data-id="element-116">→</span>
          <div className="flex items-center gap-3 justify-center py-2" data-id="element-117">
            <div className="w-10 h-10 bg-green-100 rounded-full flex items-center justify-center text-green-600 flex-shrink-0" data-id="element-118">
              <CreditCard className="w-5 h-5" data-id="element-119" />
            </div>
            <p className="text-gray-700 text-base" data-id="element-120">
              <span className="font-bold" data-id="element-121">2.</span> Pagás de forma segura
            </p>
          </div>
          <span className="hidden md:block text-gray-300 text-2xl" data-id="element-122">→</span>
          <div className="flex items-center gap-3 justify-center py-2" data-id="element-123">
            <div className="w-10 h-10 bg-purple-100 rounded-full flex items-center justify-center text-purple-600 flex-shrink-0" data-id="element-124">
              <Download className="w-5 h-5" data-id="element-125" />
            </div>
            <p className="text-gray-700 text-base" data-id="element-126">
              <span className="font-bold" data-id="element-127">3.</span> Recibís el link de descarga
            </p>
          </div>
        </div>

        <p className="mt-3 md:mt-6 text-sm text-gray-500 text-center" data-id="element-128">
          ⚠️ Si no lo ves en tu bandeja principal, revisá spam.
        </p>
      </div>
    </section>;
}